import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom, Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { getPlaneaciones, getPlaneacionesMenu, getPlaneacionId } from './querys';

export class Planificacion {
  public id?: Number;
  public name?: String;
  public initial_date?: Date;
  public end_date?: Date;
  public isActive?: boolean;
  public institutionId?: Number;
  public business_days?: string;
  public responsibleId?: number;
  public enableMailReports?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PlanificacionService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private http: HttpClient,
    private cookies: CookieService,
    private apollo: Apollo,
  ) {}

  public getInstituciones(): Observable<any> {
    const apiURL = this.apiURL + "institucion";
    return this.http.get(`${apiURL}`, { headers: this.headers });
  }

  getPlanificacionById(id: number): Observable <any>{
    const urlApi = `${this.apiURL}planificacion/${id}`;
    return this.http.get(urlApi, {headers: this.headers});
  }
  
  async getPlanificacionesGQL(){
    const allData: any[] = [];
    let currentPage = 1;
    let hasNextPage = true;

    while (hasNextPage) {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
          query: getPlaneaciones,
          context: { headers: this.headers },
          variables: {
            args: {
              pagination: {
                page: currentPage
              }
            }
          },
          fetchPolicy: 'no-cache'
        }).valueChanges
      );

      const { data: plannings, metadata } = data.searchPlannings;
      allData.push(...plannings);

      hasNextPage = metadata.hasNextPage;
      currentPage++;
    }

    return allData;
  }
  async getPlanificacionesGQLMenu(){
    const allData: any[] = [];
    let currentPage = 1;
    let hasNextPage = true;

    while (hasNextPage) {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
          query: getPlaneacionesMenu,
          context: { headers: this.headers },
          variables: {
            args: {
              pagination: {
                page: currentPage
              }
            }
          },
          fetchPolicy: 'no-cache'
        }).valueChanges
      );

      const { data: plannings, metadata } = data.searchPlannings;
      allData.push(...plannings);

      hasNextPage = metadata.hasNextPage;
      currentPage++;
    }

    return allData;
  }
  async getPlanificacionByIdGQL(id: number){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
        query: getPlaneacionId,
        context: {headers: this.headers},
        variables: {planningId: id},
        fetchPolicy: 'no-cache'
      }).valueChanges
    );
    return data.planning;
  }

  public postPlan(plan: any): Observable<any> {
    const planif: Planificacion = {
      name: plan.nombre,
      initial_date: plan.fecha_inicio.toISOString(),
      end_date: plan.fecha_fin.toISOString(),
      isActive: Boolean(plan.isActive),
      institutionId: plan.institucionId,
      business_days: plan.business_days,
      responsibleId: Number(plan.responsible),
    }
    const body = JSON.stringify(planif);
    const apiURL = this.apiURL + "planificacion";
    return this.http.post(`${apiURL}`, body, { headers: this.headers });
  }
  public patchPlan(plann: any): Observable<any> {
    const planni: Planificacion = {
      name: plann.nombre,
      initial_date: plann.fecha_inicio.toISOString(),
      end_date: plann.fecha_fin.toISOString(),
      isActive: Boolean(plann.isActive),
      institutionId: plann.institucionId,
      business_days: plann.business_days,
      responsibleId: Number(plann.responsible),
    }
    const body = JSON.stringify(planni);
    const apiURL = this.apiURL + "planificacion/" + plann.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public patchPlanNotificaciones(plann: any): Observable<any> {
    const planni: Planificacion = {
      enableMailReports: plann.enableMailReports,
    }
    const body = JSON.stringify(planni);
    const apiURL = this.apiURL + "planificacion/" + plann.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }
  public patchPlanEdicion(plann: any): Observable<any> {
    const planni: Planificacion = {
      isActive: plann.isActive,
    }
    const body = JSON.stringify(planni);
    const apiURL = this.apiURL + "planificacion/" + plann.id;
    return this.http.patch(`${apiURL}`, body, { headers: this.headers });
  }

  public deletePlan(plann: any): Observable<any> {
    const apiURL = this.apiURL + "planificacion/" + plann.id;
    return this.http.delete(`${apiURL}`, { headers: this.headers });
  }

  public patchReportIntro(planId: string, reportIntro: string) {
    const apiUrl = this.apiURL + "planificacion/" + planId;
    return this.http.patch(apiUrl, { 'report_intro': reportIntro }, { headers: this.headers },);
  }
}
